import apiService from "./api";
import { sanitizeQueryParams } from "../utility/helpers/apiHelper";
import type { TableSortValue } from "@src/shared/constants/sort-order.constants";
import type { PaginationAndOrderParams } from "@src/shared/types/pagination.types";

export interface GetInvoicesParams
  extends Partial<
    Omit<PaginationAndOrderParams, "page" | "pageSize" | "orderDirection">
  > {
  page?: number | string;
  pageSize?: number | string;
  search?: string;
  status?: string;
  documentType?: string;
  orderDirection?: TableSortValue;
}

export class InvoiceService {
  async getInvoices(query: GetInvoicesParams) {
    return apiService.get("/invoices", {
      params: sanitizeQueryParams(query),
    });
  }

  async getInvoice(id: string | number) {
    return apiService.get(`/invoices/${id}`);
  }
}

export const invoiceService = new InvoiceService();
